import React from "react";
import SupportLayout from "./SupportLayout";
import AdminInterventionsContent from "../admin/components/AdminInterventionsContent";

const InterventionPage = ({ userRole = "SO" }) => {
  return (
    <SupportLayout userRole={userRole}>
      <AdminInterventionsContent useOwnLayout={false} userRole={userRole} />
    </SupportLayout>
  );
};

export default InterventionPage;
